import type { PaymentMethod } from "@jti/fe-common/types";

export const sortMethodsByAvailability = (methods: PaymentMethod[]): PaymentMethod[] => {
  return [...methods].sort((a, b) => {
    const aValue = a.enabled ? 0 : 1;
    const bValue = b.enabled ? 0 : 1;

    return aValue - bValue;
  });
};
